export class StepState
{
    stepIdx: number;
    valid: boolean;

    constructor(stepIdx: number, valid: boolean)
    {
        this.stepIdx = stepIdx;
        this.valid = valid;
    }
}
